import { DeviceUiState } from './types'

export const state: DeviceUiState = {
  loading: false,
}
